module.exports = __webpack_public_path__ + "img/logo_mb.ced7a88f.png";